import { Tour, TourByIdQuery, TourStatus } from "@graphql/types";
import { getCurrencyConversion } from "@helpers/getCurrencyConversion";
import { Trans } from "@helpers/translate";
import React, { FC, useState } from "react";
import { SidebarModal } from "./SidebarModal";
import { Fields } from "./Sidebar";
import { Button } from "@components/ui/Button";
import { useAuth } from "@helpers/hooks/useAuth";
import { ROUTES } from "@root/routes";
import { useRouter } from "next/router";

type Props = {
  tour: NonNullable<TourByIdQuery["tourById"]>;
  onCheckOut?: (fileds: Fields) => void | undefined;
};

export const SidebarMobile: FC<Props> = ({ tour, onCheckOut }) => {
  const [showModal, setShowModal] = useState(false);

  const isInvalidTour = (tour: Tour) => {
    return tour.status === TourStatus.Inactive || tour.supplier.isBan;
  };

  const router = useRouter();

  const { auth } = useAuth();

  const sendMessage = () => {
    if (auth) {
      router.push(
        ROUTES.supplier(tour.supplier.id).message.form({
          tourId: tour.id,
        })
      );
      return;
    }

    router.push(
      ROUTES.supplier(tour.supplier.id).message.signup({
        tourId: tour.id,
      })
    );
  };

  return (
    <div>
      {showModal && (
        <SidebarModal
          tour={tour}
          onCheckOut={(fields: Fields) => {
            setShowModal(false);
            onCheckOut && onCheckOut(fields);
          }}
          onClose={() => {
            setShowModal(false);
          }}
        />
      )}
      <div className="lg:hidden fixed bottom-0 left-0 right-0 bg-white p-4 py-2 border-t z-10">
        <div className="grid grid-cols-2 gap-3 items-center justify-between">
          <div className="text-center flex flex-col w-full h-full">
            <span className="text-gray-500 text-sm font-normal mx-2 mb-auto">
              Want to Personalize?
            </span>

            <Button
              onClick={sendMessage}
              className="w-full bg-blue-700 font-normal mt-2 cursor-pointer"
              disabled={isInvalidTour(tour as Tour)}
              rounded
              title="GoWithGuide - Send a message"
              variant="secondary"
            >
              <Trans id="tour.block.send-message.button">Send a Message</Trans>
            </Button>
          </div>
          <div className="flex flex-col text-center w-full">
            <p>
              <b
                className="text-gray-800 text-base mx-2"
                suppressHydrationWarning
              >
                {getCurrencyConversion(tour.price.amount, tour.price.currency)}
              </b>
              <span className="text-gray-500">
                {tour.price.model === "PERSON" && (
                  <Trans id="tour.price.per_person">/ per person</Trans>
                )}
                {tour.price.model === "GROUP" && (
                  <Trans id="tour.price.per_group">/ per group</Trans>
                )}
              </span>
            </p>

            <Button
              className="w-full text-gray-700 font-normal mt-2 cursor-pointer"
              rounded
              variant="yellow2"
              onClick={() => {
                setShowModal(true);
              }}
            >
              Reserve
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};
